// utils/helpers.js — Shared utility functions

// Generate unique IDs
export const genId = () => Math.random().toString(36).slice(2, 9);

// Read a file as base64 data URL
export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

// Clamp a number between min and max
export const clamp = (val, min, max) => Math.max(min, Math.min(max, val));

// Deep merge two objects
export const deepMerge = (target, source) => {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
      result[key] = deepMerge(target[key] ?? {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
};

// Truncate string to length
export const truncate = (str, len = 80) =>
  str && str.length > len ? str.slice(0, len) + "…" : str;

// Format WhatsApp link
export const whatsappLink = (number, message = "") =>
  `https://wa.me/${number.replace(/\D/g, "")}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
